import createApp from './app.js'

import messagingService from './service.messaging.js'

const appConfig = {"apiKey":"AIzaSyD_sEXWPCzWyEcE94GgBMzUTJObJ827ERE","authDomain":"my-project-1522740117602.firebaseapp.com","databaseURL":"https:\u002F\u002Fmy-project-1522740117602.firebaseio.com","projectId":"my-project-1522740117602","storageBucket":"my-project-1522740117602.appspot.com","messagingSenderId":"517590175305","appId":"1:517590175305:web:6a299ef1150e41d7763998","measurementId":"G-N9GEETVZG5"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.client) {
    servicePromises = [
      messagingService(session, firebase, ctx, inject),

    ]
  }

  const [
    messaging
  ] = await Promise.all(servicePromises)

  const fire = {
    messaging: messaging
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}